import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import {
  IDocumentAssemblerGenerationListResponse,
  TDocumentAssemblerListGenerationsParams,
} from './generation-types';
import { GENERATIONS_URL } from './helpers';

export const useDocumentAssemblerGenerations = (
  options?: TDocumentAssemblerListGenerationsParams & { enabled?: boolean }
) => {
  const query = new URLSearchParams();
  if (options?.templateId) query.append('templateId', options.templateId);
  if (options?.templateVersionId)
    query.append('templateVersionId', options.templateVersionId);
  if (options?.companyId !== undefined)
    query.append('companyId', options.companyId.toString());
  if (options?.status) query.append('status', options.status);
  if (options?.limit !== undefined)
    query.append('limit', options.limit.toString());
  if (options?.offset !== undefined)
    query.append('offset', options.offset.toString());

  const search = query.toString();
  const isEnabled = options?.enabled ?? true;

  const { data, error, isLoading, mutate } =
    useSWR<IDocumentAssemblerGenerationListResponse>(
      isEnabled ? `${GENERATIONS_URL}${search ? `?${search}` : ''}` : null,
      SWRFetcher({ method: 'GET' })
    );

  return {
    generations: data?.generations,
    count: data?.count,
    error,
    isLoading,
    mutate,
  };
};
